import React, {Component} from 'react';
import {Add, Delete as DeleteIcon, Description, Edit, Style} from '@mui/icons-material';
import {Box, Button, CircularProgress, IconButton, Tab, Tabs, Tooltip} from '@mui/material';
import {connect} from 'react-redux';

import {getTemplate} from '../../actions/template';
import Table from '../../components/Table';
import {dateFormat} from '../../lib/utils';
import Delete from './Delete';
import HeadersTab from './HeadersTab';
import TemplateForm from './TemplateForm';

class Template extends Component {
  constructor(props) {
    super(props);
    this.state = {
      templateList: [],
      selectedTemplate: null,
      showAdd: false,
      showDelete: false,
      // ?tab=headers (the dashboard's Header / Sender ID card) opens on Headers.
      activeTab: new URLSearchParams(window.location.search).get('tab') === 'headers' ? 1 : 0
    };
    this.receiveTemplate = false;
  }
  componentDidMount() {
    this.props.getTemplate();
  }
  componentWillReceiveProps(nextProps) {
    const {templateList} = nextProps;
    if (this.receiveTemplate === false && this.state.templateList.length === 0 && templateList && templateList.data) {
      if (templateList.success) {
        this.receiveTemplate = true;
        this.setState({templateList: templateList.data.template || []});
      } else if (templateList.err) {
        alert(templateList.err.msg);
        this.receiveTemplate = true;
      } else {
        alert('Something went wrong!');
        window.location.reload();
      }
    }
  }
  handleClose = () => {
    this.setState({selectedTemplate: null, showDelete: false});
  }
  handleSuccess = () => {
    this.receiveTemplate = false;
    this.props.getTemplate();
    this.setState({selectedTemplate: null, templateList: [], showAdd: false, showDelete: false});
  }
  toggleAdd = (e) => {
    e.stopPropagation()
    this.setState(prevState => ({showAdd: !prevState.showAdd, selectedTemplate: null}))
  }
  deleteTemplate = (e, data) => {
    e.stopPropagation()
    this.setState({selectedTemplate: data, showDelete: true})
  }
  editTemplate = (e, data) => {
    e.stopPropagation()
    this.setState({selectedTemplate: data, showAdd: true})
  }
  renderTemplatesTab() {
    const {templateList, selectedTemplate, showAdd, showDelete} = this.state;
    return (
      <div>
        <div style={{display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap'}}>
          <p style={{fontSize: '1rem'}}>{templateList.length > 0 ? templateList.length : '' } Templates</p>
          <Button onClick={this.toggleAdd} startIcon={<Add />} variant='contained' style={{marginLeft: 'auto'}}>Add Template</Button>
        </div>
        {
          templateList.length ?
            <div style={ {paddingTop: 16} }>
              <Table
                column={[
                  {name: 'Header', value: 'header', style:{width: '10%'}}, 
                  {name: 'Template Name', value: 'templateUserName', style:{minWidth: 135}},
                  {name: 'Template', value: 'text', style:{width: '20%', whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: 1.3}},
                  {name: 'Template ID', value: 'templateId', style:{width: '15%'}}, {name: 'updatedAt', value: 'updatedAt', style:{width: '18%'}, cell: val => val ? dateFormat(val) : '--'},
                  {name: 'Action', style:{width: '15%'}, value: '', cell:  (id, original) => (<><Tooltip title="Edit Template">
                    <IconButton aria-label="Edit" onClick={e => this.editTemplate(e, original)}>
                      <Edit />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Delete Template">
                    <IconButton aria-label="Delete" onClick={e => this.deleteTemplate(e, original)}>
                      <DeleteIcon />
                    </IconButton>
                  </Tooltip></>)}
                ]}
                data={templateList}
              />
            </div>
            :
            <div>
              {
                this.receiveTemplate ?
                  <div>
                    <p style={ {padding: 50, fontSize: 16, color: '#333', paddingBottom: 20} }>Currently No Template is added, Please add templates!</p>
                  </div>

                  :
                  <CircularProgress size={ 80 } thickness={ 5 } />
              }
            </div>
        }
        {
          showDelete &&
          <Delete
            handleSuccess={ this.handleSuccess }
            data={ selectedTemplate }
            onClose={ this.handleClose }
          />
        }
        {showAdd &&
          <TemplateForm
            handlePostTemplate={ this.handleSuccess }
            closeHandler={ this.toggleAdd }
            data={ selectedTemplate }
          />
        }
      </div>
    );
  }

  render() {
    const {activeTab} = this.state;
    const isMobile = window.isMobile();
    return (
      <div className='sms-parent-container' style={isMobile ? {padding: 8} : {}}>
        <Box sx={{borderBottom: 1, borderColor: 'divider', mb: 2}}>
          <Tabs
            value={activeTab}
            onChange={(e, val) => this.setState({activeTab: val})}
            variant="scrollable"
            scrollButtons="auto"
          >
            <Tab icon={<Description />} iconPosition="start" label="Templates" />
            <Tab icon={<Style />} iconPosition="start" label="Headers" />
          </Tabs>
        </Box>

        {activeTab === 0 && this.renderTemplatesTab()}
        {activeTab === 1 && <HeadersTab />}
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    templateList: state.template.templateList
  };
}

export default connect(mapStateToProps, {getTemplate})(Template);
